import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { FDPagination, FDSecondaryActionIconButton, FDStack } from '@facet-wealth/design';
import PropTypes from 'prop-types';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { useItemListContext } from '../ItemContext';
import { queryFormMetaOverrideSet } from './queryFormMetaOverrideSet';

const useStyles = buildUseStyles('SelectScenarioButton', theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: `${theme.spacing(2)}px`,
    width: '100%',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
  },
  filters: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flexGrow: 1,
    gap: `${theme.spacing(2)}px`,
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
  },
}));

const Layout = ({ onSubmit }) => {
  const { resource, handleChange } = useMetaLayoutContext();
  const attributes = resource.attributes();
  const attributesArray = Object.keys(attributes);
  const {
    loading,
    hasNextPage,
    hasPrevPage,
    pageNumber,
    getNextPage,
    getPrevPage,
  } = useItemListContext();

  const classes = useStyles();

  const nonHiddenFields = attributesArray.filter((attr) => {
    const metaField = resource.metaField(attr, { metaOverrideSet: queryFormMetaOverrideSet });
    return !metaField.attr('hidden');
  });
  const hasVisibleFilters = nonHiddenFields.length > 0;

  return (
    <Box className={classes.root}>
      <Box className={classes.filters}>
        {nonHiddenFields.map(attr => (
          <div key={attr} style={{ maxWidth: 200, width: '100%' }}>
            <MetaControlField hideViaMetaOverride attr={attr} resource={resource} onInlineSubmit={onSubmit} />
          </div>
        ))}
      </Box>
      <FDStack alignItems={'center'} justifyContent={'flex-end'} spacing={2} width={1}>
        {hasVisibleFilters ? <FDSecondaryActionIconButton
          icon={'close'}
          label={'Clear Filters'}
          onClick={() => {
            resource.meta().template().list().forEach(metaField => {
              handleChange(metaField.attr('name'), '');
            });
            return onSubmit();
          }}
        /> : null }
        <FDSecondaryActionIconButton
          icon={'refresh'}
          label={'Refresh'}
          onClick={() => {
            return onSubmit();
          }}
        />
        {(hasPrevPage || hasNextPage) ? (
          <FDPagination
            page={pageNumber}
            hasNextPage={hasNextPage}
            onChange={(change, newPageNumber) => {
              if (newPageNumber > pageNumber) {
                getNextPage();
              } else if (newPageNumber < pageNumber) {
                getPrevPage();
              }
            }}
            loading={loading}
          />
        ) : null}
      </FDStack>
    </Box>
  );
};

Layout.defaultProps = {
  onSubmit: null,
};

Layout.propTypes = {
  onSubmit: PropTypes.func,
};

export default Layout;
